import React, { Component } from "react";
import styles from "./VehicleSpecs.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Grid from "@material-ui/core/Grid";
import { GetFloatToFixedValue } from "../../../../utils/GetFloatValue";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../../utils/EmpUtil";
import { withTranslation } from "react-i18next";

class CvVehicleSpecsHercules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandSpecsInfo: true,
    };
  }

  expandSpecsInfo() {
    this.setState((prevState) => ({
      expandSpecsInfo: !prevState.expandSpecsInfo,
    }));
  }

  render() {
    const data = this.props.pricingStack;
    const defaultCurrency = this.props.defaultCurrency;

    function specsRow(styling, displayText, secondText, key = "") {
      return (
        displayText && (
          <Grid container key={key === "" ? displayText : key}>
            <Grid item xs={11} className={styling}>
              <div>{displayText}</div>
            </Grid>
            <Grid item xs={1} className={styling}>
              {secondText && (
                <div className={styles.priceValue}>{secondText}</div>
              )}
            </Grid>
          </Grid>
        )
      );
    }

    function formatPriceValue(value) {
      if (NOTNULL_OR_NOTUNDEFINED(value)) {
        value = GetFloatToFixedValue(value, 2);
        value = value.toString();
        value =
          value.charAt(0) === "+" || value.charAt(0) === "-"
            ? value.charAt(0).concat(defaultCurrency, value.substr(1))
            : defaultCurrency.concat(value);
      } else {
        value = "--";
      }
      return value;
    }

    return (
      <StyledBasicExpansionPanel
        expanded={
          this.props.offlinePricingUpdate.partialOffline
            ? false
            : this.state.expandSpecsInfo
        }
        disabled={this.props.offlinePricingUpdate.partialOffline}
        onChange={() => this.expandSpecsInfo()}
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.headerBarNeutral}
          id="exp"
        >
          <div className={sharedStyles.headerBar}>
            <div className={sharedStyles.boldHeader}>
              {this.props.offlinePricingUpdate.partialOffline
                ? this.props.t(
                    "CustomerOrderDetails.vehicleSpecsHeaderPricingAgreed"
                  )
                : this.props.t("CustomerOrderDetails.vehicleSpecsHeader")}
            </div>
            {!this.props.offlinePricingUpdate.partialOffline &&
              (this.state.expandSpecsInfo ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              ))}
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>

        <div className={styles.vehicleInfoGrid}>
          <div className={styles.bottomBorder} />

          {data ? (
            <Grid container className={styles.specsContainer}>
              {specsRow(
                styles.lightHeader,
                this.props.t("VehicleSpecs.basePriceExcludingVat"),
                formatPriceValue(data.basePriceNetRetail)
              )}

              {specsRow(
                styles.darkHeader,
                this.props.t("VehicleSpecs.configureOptionsExcludingVat"),
                formatPriceValue(data.selectedFeaturePriceNetRetail)
              )}

              {data.userSelectedFeatures &&
                data.userSelectedFeatures.map((feature, index) =>
                  specsRow(
                    styles.darkIndentDetails,
                    feature.type,
                    formatPriceValue(feature.value),
                    index
                  )
                )}
              <>
                {specsRow(
                  styles.lightHeader,
                  this.props.t("VehicleSpecs.totalVehiclePriceExcludingVat"),
                  formatPriceValue(data.netRetailPriceWithoutIncentives)
                )}

                {specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.keyinHandcostCVTotalNet"),
                  formatPriceValue(data.keyinHandcostCVTotalNet)
                )}

                {specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.unavoidableCostCVTotalNet"),
                  formatPriceValue(data.unavoidablecostCVTotalNet)
                )}

                {specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.otrPromotionalPriceExclVatAndBpm"),
                  formatPriceValue(data.promotionalPriceExcVATAndRegTax)
                )}

                {specsRow(
                  styles.lightHeader,
                  this.props.t("VehicleSpecs.totalPriceExcludingVatAndBpm"),
                  formatPriceValue(data.promotionalPriceExcVATAndRegTax)
                )}

                {specsRow(
                  styles.lightIndentDetails,
                  this.props.t("VehicleSpecs.vat"),
                  formatPriceValue(
                    data.vatAmountWithOTRAndIncentivesAndAccessories
                  )
                )}

                {specsRow(
                  styles.lightIndentDetails,
                  this.props.t("VehicleSpecs.vehicleTaxIncludingOptions"),
                  formatPriceValue(data.registrationTax)
                )}

                {specsRow(
                  styles.darkHeader,
                  this.props.t("VehicleSpecs.totalPriceIncludingVatAndBpm"),
                  formatPriceValue(data.totalPriceWithAddOns)
                )}
              </>
            </Grid>
          ) : (
            <span className={styles.labelError}>
              {this.props.t("CustomerOrderDetails.errorLoadingDetails")}
            </span>
          )}
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(CvVehicleSpecsHercules);
